import { v4 as uuidv4 } from "uuid"

import supabase from "@/supabase"

export interface DocumentRecord {
  id: string
  application_id: string
  type: string
  file: string
  status: "Pending" | "Verified" | "Rejected"
  created_at?: string
  updated_at?: string
}

/**
 * Create a new document record in the documents table
 * @param applicationId Application ID
 * @param type Document type (e.g., 'dvla-front', 'dvla-back', 'rtw', 'insurance')
 * @param fileUrl URL of the uploaded file
 * @returns Promise with the created document record or error
 */
export const createDocumentRecord = async (
  applicationId: string,
  type: string,
  fileUrl: string,
): Promise<{ data: DocumentRecord | null; error: Error | null }> => {
  try {
    const documentRecord: Omit<DocumentRecord, "id" | "created_at" | "updated_at"> = {
      application_id: applicationId,
      type,
      file: fileUrl,
      status: "Pending", // Default status for new documents
    }

    const { data, error } = await supabase
      .from("documents")
      .insert([{ id: uuidv4(), ...documentRecord }])
      .select()
      .single()

    if (error) {
      console.error("Error creating document record:", error)
      return { data: null, error }
    }

    return { data, error: null }
  } catch (error) {
    console.error("Unexpected error in createDocumentRecord:", error)
    return {
      data: null,
      error: error instanceof Error ? error : new Error("An unexpected error occurred"),
    }
  }
}
